const lang = {
  component: {
    ChatbotPopup: {
      pTagFirst: 'مرحبًا، أنا ألما.',
      pTagSecond: 'تم تصميمي للإجابة عن أسئلتك المتعلقة',
      pTagThird: 'بنمو الأطفال',
      pTagFourth: '. كيف يمكنني مساعدتك؟',
      button: {
        copy: 'اسأل ألما',
        label: 'اطرح سؤالك'
      }
    },
    CookieNotification: {
      pTagTop: 'تستخدم هذه الصفحة ملفات تعريف الارتباط من أجل تقديم تجربة تصفح رائعة لك.',
      pTagBottom: 'بالمتابعة، يعني هذا أنك توافق على',
      anchorText: 'سياسة ملفات تعريف الارتباط الخاصة بنا'
    },
    GrowthCalculator: {
      form: {
        fields: {
          age: 'العمر',
          years: 'سنوات',
          months: 'أشهر',
          dob: 'تاريخ الميلاد',
          gender: 'النوع',
          genderSelect: {
            boy: 'ذكر',
            girl: 'أنثى'
          },
          fathersHeight: 'طول الأب',
          mothersHeight: 'طول الأم',
          measuredDate: 'التاريخ',
          measuredHeight: 'الطول',
          measuredWeight: 'الوزن'
        },
        chooseDataset: {
          label: 'اختر قاعدة البيانات',
          pTagFirst: 'البيانات المُستخدمة لعمل هذه الرسوم البيانية مأخوذة من البيانات المرجعية لمنظمة الصحة العالمية (WHO)\u200f 2006 / 2007. يُرجى الأخذ في الاعتبار أن مخططات النمو لمنظمة الصحة العالمية (WHO) ليست خاصة ببلد بعينها؛ ويمكن لمختصّي الرعاية الصحية المساعدة في تقييم نمو طفلك باستخدام مخططات النمو المناسبة لكل بلد.',
          pTagSecond: 'البيانات المرجعية للطول متاحة للأعمار من وقت الولادة حتى 19 عامًا.',
          dataSetUK: 'جداول البيانات الخاصة بالمملكة المتحدة',
          dataSetUS: 'جداول البيانات الخاصة بالولايات المتحدة الأمريكية',
          metricSystem: {
            metric: 'النظام المتري',
            imperial: 'النظام الإمبراطوري (الإنجليزي)'
          }
        },
        basicInformation: {
          legend: 'المعلومات الأساسية'
        },
        childsMeasurements: {
          firstLegend: 'يُرجى إدخال طول الأبوين من أجل عرض الطول المُستهدف لطفلك',
          secondLegend: 'يُرجى إدخال قياسات طفلك',
          label: 'كيفية قياس طول طفلك',
          popUp1: {
            pTagFirst: 'دليل استرشادي للطول المتوقع لطفلك',
            pTagSecond: 'يوضح هذا الشكل متوسط الطول المتوقع لطفلك، عندما يكتمل النمو. ',
            pTagThird: 'هذا الشكل مبني على طول كلا الأبوين، حيث أنه يوضح إحتماليات النمو الوراثية. على سبيل المثال، تزيد احتمالية طول قامة الطفل عندما يكون الأبوين من طوال القامة.',
            pTagFourth: 'يُدعى هذا الشكل، الطول المُستهدف للطفل.',
            pTagFifth: 'هايموند إم وآخرون، أكتا لطب الأطفال 2013؛ \u200e102(8):787-796.'
          },
          popUp2: {
            popupTitleLarge: 'كيفية قياس طول طفلك',
            pTagFirst: 'الحصول على قياسات دقيقة لطفلك هو أمر مهم. من الأفضل استخدام قياسات طفلك المأخوذة بواسطة طبيبك. إن لم تكن لديك تلك القياسات، اتبع الطريقة الموضحة هنا للحصول عليها. ',
            popupTitle: 'قياس الطول',
            pTagSecond: 'إن كنت تقوم بأخذ قياسات طفلك في المنزل، من المهم أن تأخذ القياسات باستخدام نفس الأدوات في كل مرة، ومن الأفضل أن يتم ذلك في نفس الوقت من اليوم. ',
            pTagThird: 'يمكن الحصول على أفضل نتائج باتباع تلك الخطوات: ',
            olTag: [
              'اشبك شريط القياس بسطح مستوٍ، مثل حائط أو باب. يجب أن يتم القياس على أرضية صلبة، أي بدون سجادة.',
              'اخلع نعليّ طفلك.',
              'أطلب من طفلك أن يقف في مقابل السطح المستو، بحيث يلامس كل من الكعبين والمؤخرة والأكتاف ومؤخرة الرأس الحائط أو الباب. يجب أن تكون قدميّ الطفل مستويتان على الأرض. ',
              'قرّب كتابًا أو ما يماثله من رأس طفلك حتى يلامسها من الأعلى، وبحيث يُشكِّل زاوية قائمة مع السطح المستو، ثم ضع علامة أمام هذا الطول على الباب أو الحائط.',
              'اقرأ الطول الموجود على شريط القياس بجوار العلامة.',
              'ادخل قياس الطول وتاريخ أخذ القياس في حقول الإدخال المناسبة.'
            ],
            pTagFourth: 'ملحوظة: تُستخدم هذه الطريقة في القياس للأطفال الأكبر من عمر العامين. تختلف الطريقة المُستخدمة لقياس طول الأطفال الأصغر من سن العامين عن الطريقة المُستخدَمة لقياس طول الأطفال الأكبر من عامين.',
            pTagFifth: 'مراكز مكافحة الأمراض والطب الوقائي. قياس طول ووزن الأطفال في المنزل بطريقة دقيقة. متاح على الموقع الإلكتروني: https://www.cdc.gov/healthyweight/assessing/bmi/childrens_bmi/measuring_children.html (آخر دخول في فبراير 2019).'
          }
        },
        buttons: {
          submit: 'إدخال',
          addNewRow: 'إضافة سطر جديد',
          clearData: 'حذف البيانات',
          downloadPDF: 'تنزيل ملف PDF',
          saveData: 'حفظ البيانات',
          calculateTargetHeight: 'حساب الطول المُستهدف',
          uploadPreviousData: 'رفع بيانات سابقة'
        },
        abnormalWarning: {
          pTagFirst: 'تقع قياسات الطول والنمو الخاصة بطفلك باستمرار خارج النطاقات المتوقعة المناسبة لعمره ووزنه ونوعه.',
          pTagSecond: 'قد يكون ضعف النمو علامة على وجود مشكلة صحية.',
          pTagThird: 'ننصح بأن تتناقش مع طبيبك.',
          pTagFourth: 'هايموند إم وآخرون، أكتا لطب الأطفال 2013؛ \u200e102(8):787-796.'
        },
        enterBasicHeight: 'يُرجى إدخال المعلومات الأساسية أولاً.',
        childsTargetHeight: 'الطول المُستهدف للطفل'
      },
      legend: {
        spanTagFirst: ' المعدل الطبيعي',
        spanTagSecond: 'للطفل',
        pTagFirst: 'البيانات المُستخدمة لعمل هذه الرسوم البيانية مأخوذة من البيانات المرجعية لمنظمة الصحة العالمية (WHO)\u200f 2006 / 2007. يُرجى الأخذ في الاعتبار أن مخططات النمو لمنظمة الصحة العالمية (WHO) ليست خاصة ببلد بعينها؛ ويمكن لمختصّي الرعاية الصحية المساعدة في تقييم نمو طفلك باستخدام مخططات النمو المناسبة لكل بلد.',
        pTagSecond: 'البيانات المرجعية للطول متاحة للأعمار من وقت الولادة حتى 19 عامًا.',
        dataSetUK: 'جداول البيانات الخاصة بالمملكة المتحدة',
        dataSetUS: 'جداول البيانات الخاصة بالولايات المتحدة الأمريكية',
        graphDeviation: {
          label: 'الانحراف المعياري',
          popUp: {
            pTagFirst: 'الانحراف المعياري، SD',
            pTagSecond: 'الانحراف المعياري هو مقياس للتنوع الإحصائي يُستخدم على نطاق واسع. هو مقياس يحدد مدى انتشار الأرقام، ويوضح مقدار اختلاف قياسٍ ما عن القيمة المتوسطة للمجموعة.',
            pTagThird: 'درجة الانحراف المعياري، SDS',
            pTagFourth: 'توضح درجة الانحراف المعياري عدد الانحرافات المعيارية التي يزيد أو يقل بها قياس ما عن القيمة المتوسطة لقياسات بمجموعة بعينها.',
            pTagFifth: 'القيمة المتوسطة',
            pTagSixth: 'القيمة المتوسطة هي متوسط كل الأرقام. هي حاصل جمع كل الأرقام في مجموعة ما، مقسومًا على عدد الأرقام الموجودة في تلك المجموعة'
          }
        }
      },
      datasets: [
        {
          value: 'who',
          text: 'منظمة الصحة العالمية'
        }
      ],
      tooltip: {
        addData: 'أضف قياسات جديدة لجدول الرسم البياني',
        saveData: 'احفظ بيانات الرسم البياني في ملف لاستخدامه مستقبلاً.',
        shareData: 'شارك بيانات الرسم البياني الخاص بك لاستخدامها مستقبلاً.',
        downloadData: 'قم بتنزيل المخططات على هيئة ملف PDF عندما تنتهي. يمكنك طباعتها لمناقشتها مع الطبيب.',
        clearData: 'احذف بياناتك من الرسم البياني'
      }
    },
    Loading: {
      label: 'جارٍ التحميل'
    },
    Chatbot: {
      disclaimer: 'تساعدنا المعلومات التي تشاركها على تقديم إجابات مفيدة. للمزيد من المعلومات، يُرجى إلقاء نظرة على',
      privacyPolicy: 'سياسة الخصوصية الخاصة بنا',
      submitBtnTxt: 'إرسال'
    },
    Legend: {
      spanTagFirst: 'المعدل الطبيعي',
      spanTagSecond: 'للطفل',
      spanTagThird: 'الانحراف المعياري',
      heightText: 'الطول',
      weightText: 'الوزن',
      pTagFirst: 'البيانات المُستخدمة لعمل هذه الرسوم البيانية مأخوذة من البيانات المرجعية لمنظمة الصحة العالمية (WHO)\u200f 2006 / 2007. يُرجى الأخذ في الاعتبار أن مخططات النمو لمنظمة الصحة العالمية (WHO) ليست خاصة ببلد بعينها؛ ويمكن لمختصّي الرعاية الصحية المساعدة في تقييم نمو طفلك باستخدام مخططات النمو المناسبة لكل بلد.',
      pTagSecond: 'البيانات المرجعية للطول متاحة للأعمار من وقت الولادة حتى 19 عامًا.',
      graphDeviation: {
        pTagFirst: 'الانحراف المعياري، SD',
        pTagSecond: 'الانحراف المعياري هو مقياس للتنوع الإحصائي يُستخدم على نطاق واسع. هو مقياس يحدد مدى انتشار الأرقام، ويوضح مقدار اختلاف قياسٍ ما عن القيمة المتوسطة للمجموعة.',
        pTagThird: 'درجة الانحراف المعياري، SDS',
        pTagFourth: 'توضح درجة الانحراف المعياري عدد الانحرافات المعيارية التي يزيد أو يقل بها قياس ما عن القيمة المتوسطة لقياسات بمجموعة بعينها.',
        pTagFifth: 'القيمة المتوسطة',
        pTagSixth: 'القيمة المتوسطة هي متوسط كل الأرقام. هي حاصل جمع كل الأرقام في مجموعة ما، مقسومًا على عدد الأرقام الموجودة في تلك المجموعة.'
      },
      dataSetUK: 'جداول البيانات الخاصة بالمملكة المتحدة',
      dataSetUS: 'جداول البيانات الخاصة بالولايات المتحدة الأمريكية'
    },
    General: {
      Buttons: {
        backToTop: 'العودة لأعلى الصفحة',
        readMore: 'اقرأ المزيد'
      }
    }
  }
}

  export default lang;
